export default __webpack_public_path__ + "static/media/armLenghMeasurement.70f9b98e.jpeg";